module.exports = require("stream");


//////////////////
// WEBPACK FOOTER
// external "stream"
// module id = 150
// module chunks = 0